import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import SamtaleterapiPage from './pages/terapi/SamtaleterapiPage';
import OnlineTerapiPage from './pages/terapi/OnlineTerapiPage';
import WalkAndTalkPage from './pages/terapi/WalkAndTalkPage';
import KunstterapiPage from './pages/terapi/KunstterapiPage';
import TestimonialsPage from './pages/TestimonialsPage';
import AboutPage from './pages/AboutPage';
import KlinikkenPage from './pages/KlinikkenPage';
import PriserPage from './pages/PriserPage';
import ContactPage from './pages/ContactPage';
import CvPage from './pages/CvPage';
import InfoPage from './pages/InfoPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-white text-[#5f7365] antialiased">
        <Header />
        
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terapi" element={<Navigate to="/terapi/samtaleterapi" replace />} />
            <Route path="/terapi/samtaleterapi" element={<SamtaleterapiPage />} />
            <Route path="/samtaleterapi" element={<SamtaleterapiPage />} />
            <Route path="/terapi/online-terapi" element={<OnlineTerapiPage />} />
            <Route path="/online-terapi" element={<OnlineTerapiPage />} />
            <Route path="/terapi/walk-and-talk" element={<WalkAndTalkPage />} />
            <Route path="/walk-and-talk" element={<WalkAndTalkPage />} />
            <Route path="/terapi/tegne-kunstterapi" element={<KunstterapiPage />} />
            <Route path="/tegne-kunstterapi" element={<KunstterapiPage />} />
            <Route path="/udtalelser" element={<TestimonialsPage />} />
            <Route path="/testimonials" element={<Navigate to="/udtalelser" replace />} />
            <Route path="/om" element={<AboutPage />} />
            <Route path="/om-mig" element={<Navigate to="/om" replace />} />
            <Route path="/about" element={<Navigate to="/om" replace />} />
            <Route path="/klinikken" element={<KlinikkenPage />} />
            <Route path="/priser" element={<PriserPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/contact" element={<Navigate to="/kontakt" replace />} />
            <Route path="/cv" element={<CvPage />} />
            <Route path="/velkomstbrev" element={<InfoPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </>
  );
}
